import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAuth } from '../../../auth/AuthContext'
import ActionItemsPanel   from '../../../components/mentor/ActionItemsPanel'
import TeamReviewActivity from '../../../components/mentor/TeamReviewActivity'
import ParentMessagesPanel from '../../../components/mentor/ParentMessagesPanel'
import StudentQuestionsPanel from '../../../components/mentor/StudentQuestionsPanel'
import WeekScheduleStrip  from '../../../components/mentor/WeekScheduleStrip'
import MyPeopleTabs       from '../../../components/mentor/MyPeopleTabs'

/**
 * Mentor dashboard — at-a-glance landing page for mentors and instructors.
 *
 * Three sections, in priority order:
 *   1. Action Items   — what needs the mentor's attention right now
 *      (topic submissions, RSVPs, attendance gaps)
 *   2. This Week      — meetings the mentor is involved with this week
 *   3. My People      — classes and 1:1 students; links into /classes/:id
 *      and /students for the full management surfaces
 *
 * Detailed student management lives on /students (canonical table view).
 * Per-class schedule editing lives on /classes/:id. The dashboard is
 * intentionally a summary, not a workspace.
 */
export default function MentorDashboard() {
  const { profile } = useAuth()

  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: 1100 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.25 }}>
        Welcome, {profile?.first_name || 'Mentor'}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Your mentoring at a glance.
      </Typography>

      <ParentMessagesPanel />
      <StudentQuestionsPanel />
      <ActionItemsPanel />
      <TeamReviewActivity />
      <WeekScheduleStrip />
      <MyPeopleTabs />
    </Box>
  )
}
